"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAPI = void 0;
var user_constants_1 = require("./user.constants");
var api_client_1 = __importDefault(require("../api-client"));
var AuthTokenService_1 = __importDefault(require("../../utils/AuthTokenService"));
var UserAPI = /** @class */ (function () {
    function UserAPI() {
    }
    UserAPI.signupUser = function (data) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.SIGNUP_USER, data);
    };
    UserAPI.signupUserMetamask = function (address) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.SIGNUP_USER_METAMASK, { address: address });
    };
    UserAPI.deleteAccount = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(user_constants_1.USER_API_URLS.DELETE_USER_ACCOUNT, {
                            data: {
                                password: password
                            },
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserAPI.login = function (data) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.LOGIN_USER, data).then(function (response) {
            var _a;
            var jwtPair = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.tokens;
            if (typeof window === 'undefined') {
                return response;
            }
            if ((jwtPair === null || jwtPair === void 0 ? void 0 : jwtPair.refresh) && (jwtPair === null || jwtPair === void 0 ? void 0 : jwtPair.access)) {
                AuthTokenService_1.default.setToken('access', jwtPair.access);
                AuthTokenService_1.default.setToken('refresh', jwtPair.refresh);
            }
            else {
                AuthTokenService_1.default.removeToken('access');
                AuthTokenService_1.default.removeToken('refresh');
            }
            return response;
        });
    };
    UserAPI.refresh = function (data) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.REFRESH, data);
    };
    UserAPI.logout = function () {
        var refresh = AuthTokenService_1.default.getToken('refresh');
        return api_client_1.default.post(user_constants_1.USER_API_URLS.LOGOUT_USER, { refresh: refresh })
            .finally(function () {
            AuthTokenService_1.default.removeToken('access');
            AuthTokenService_1.default.removeToken('refresh');
        });
    };
    UserAPI.getUserInfo = function (identity) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.GET_USER_INFO, { identity: identity });
    };
    UserAPI.getMetamaskUserInfo = function (identity) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.GET_METAMASK_USER_INFO, { identity: identity });
    };
    UserAPI.search = function (data) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.SEARCH_USERS, data);
    };
    UserAPI.updateUserProfile = function (data) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.UPDATE_PROFILE, data);
    };
    UserAPI.changeUserEmail = function (email, password) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.CHANGE_USER_EMAIL, {
            email: email,
            password: password,
        });
    };
    UserAPI.changeUserPassword = function (password, new_password) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.CHANGE_USER_PASSWORD, {
            password: password,
            new_password: new_password,
        });
    };
    UserAPI.getUserProfile = function (headers) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.GET_USER_PROFILE, {}, {
            headers: headers,
        });
    };
    UserAPI.setUserAcceptSmTerms = function (accept_sm_terms, headers) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.SET_USER_ACCEPT_SM_TERMS, { accept_sm_terms: accept_sm_terms }, {
            headers: headers,
        });
    };
    UserAPI.changeUserAvatar = function (payload) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.CHANGE_USER_AVATAR, payload);
    };
    UserAPI.removeUserAvatar = function () {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.REMOVE_USER_AVATAR, {});
    };
    UserAPI.changeUserBanner = function (payload) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.CHANGE_USER_BANNER, payload);
    };
    UserAPI.removeUserBanner = function () {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.REMOVE_USER_BANNER, {});
    };
    UserAPI.fetchUsersByIds = function (ids) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.GET_USERS_INFO_BY_IDS, { ids: ids });
    };
    UserAPI.fetchUsersByWallets = function (wallets) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.GET_USERS_INFO_BY_WALLETS, { wallets: wallets });
    };
    UserAPI.confirmUserEmail = function (data) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.CONFIRM_USER_EMAIL, data);
    };
    UserAPI.sendUserEmail = function (identity) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.SEND_USER_EMAIL, { identity: identity });
    };
    UserAPI.setPassword = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(user_constants_1.USER_API_URLS.RESET_USER_PASSWORD_CONFIRM, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserAPI.resetPassword = function (identity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(user_constants_1.USER_API_URLS.RESET_USER_PASSWORD_SEND, { identity: identity })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserAPI.validateEmail = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(user_constants_1.USER_API_URLS.VALIDATE_EMAIL, { email: email })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserAPI.validateUser = function (login) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(user_constants_1.USER_API_URLS.VALIDATE_USER, { login: login })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserAPI.getUsersHighlights = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post(user_constants_1.USER_API_URLS.GET_USERS_HIGHLIGHTS, data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserAPI.setGoogleClientId = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_client_1.default.post('/v2/user/set-ga-clint-id', {
                            clientId: clientId
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserAPI.fetchUsersByFilter = function (data) {
        return api_client_1.default.post(user_constants_1.USER_API_URLS.GET_USERS_BY_FILTER, data);
    };
    return UserAPI;
}());
exports.UserAPI = UserAPI;
